
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.48 3.958a6.496 6.496 0 01-.838 6.517l4.116 4.117a.825.825 0 11-1.167 1.166l-4.115-4.116A6.499 6.499 0 113.958.52l.199-.081a6.499 6.499 0 018.324 3.52zM4.787 1.983l-.176.07-.173.078a4.832 4.832 0 10.35-.148z"}})])
          )
        }
      }
    